import React from 'react'

const dragContext = React.createContext()
const initialState = {
  isDragging: false,
  draggingId: null,
  draggingType: null,
  dragData: null
}

const useDragState = () => {
  const [dragState, setDragState] = React.useState(initialState)

  return [
    dragState,
    {
      startDrag: ({ id, data, type }) => {
        const newState = {
          ...dragState,
          isDragging: true,
          draggingId: id,
          dragData: data,
          draggingType: type
        }
        setDragState(newState)
        return newState
      },
      stopDrag: () => {
        const newState = {
          ...dragState,
          isDragging: false,
          dragData: null,
          draggingId: null,
          draggingType: null
        }
        setDragState(newState)
        return newState
      }
    }
  ]
}

export const DragProvider = ({ children }) => {
  const [dragState, dragFunctions] = useDragState()

  return (
    <dragContext.Provider
      value={{
        state: dragState,
        dispatch: dragFunctions
      }}
    >
      {children}
    </dragContext.Provider>
  )
}

export const useDragStore = () => {
  const dragStore = React.useContext(dragContext)
  return dragStore
}

export const DragState = ({ children }) => {
  const dragStore = useDragStore()
  return children(dragStore.state)
}



// WEBPACK FOOTER //
// ./src/components/DragAndDrop/DragContext.js